
export class Question {

	id = "";
	type: "check"|"number"|"text"|"textarea" = "text";
	label = "";
	required = false;
	bIsLoop = false;
	nInLoop = 1;


	children: Question[] = [];
	childrenCondition = "";

	parentId = "";		// HauptfrageNr

	excludesQuestionId = "";
	
	// bIsDisabled field used by:
	//	the form filler, to know if the question is excluded or not
	//	the form editor, to disable the question if the form is not editable
	bIsDisabled = false;	

	sequenceNr = 0;		// reihenFolge


	// dynamic fields
	bIsVisible = false;
	value: null | string | number | boolean = null;

	deregistration = false;

}

export class BackendQuestionType {
	bezeichnung = "Input";
	component = "String";
	id = "1";
}

export class BackendQuestion {

	frageId = "";
	frage = "";
	pflichtfrage = false;
	reihenfolge = "";
	hauptfrageId = "";
	bedingung = "";
	ausschlussFragen = "";

	fragen: BackendQuestion[] = [];

	abmeldung = false;

	fragenTyp = new BackendQuestionType();
	ftId ?= "1";

	anlageDatum?: number|null = null;

}


export const EXAMPLE_TREE_BACKEND: BackendQuestion[] = [
	{
		"frageId": "1",
		frage: "Wir nähmen an der Veranstaltung teil",
		fragenTyp: { bezeichnung: "Boolean", component: "Checkbox", id: "" },
		pflichtfrage: true,
		reihenfolge: "1",
		hauptfrageId: "",
		bedingung: "",
		ausschlussFragen: "2",
		abmeldung: false,
		"fragen": [
			{
				"frageId": "3",
				frage: "Anzahl Teilnehmer",
				fragenTyp: { bezeichnung: "Boolean", component: "Mehrwach_Unterfragen", id: "" },
				pflichtfrage: true,
				reihenfolge: "1",
				hauptfrageId: "1",
				bedingung: "",
				ausschlussFragen: "",
				abmeldung: false,
				fragen: [
					{
						"frageId": "4",
						frage: "Name des Teilnehmers",
						fragenTyp: { bezeichnung: "String", component: "Text", id: "" },
						pflichtfrage: true,
						reihenfolge: "1",
						hauptfrageId: "3",
						bedingung: "",
						ausschlussFragen: "",
						fragen: [],
						abmeldung: false
					},
					{
						"frageId": "5",
						frage: "Frrühstücksbranch",
						fragenTyp: { bezeichnung: "Boolean", component: "Checkbox", id: "" },
						pflichtfrage: false,
						reihenfolge: "1",
						hauptfrageId: "3",
						bedingung: "",
						ausschlussFragen: "",
						fragen: [],
						abmeldung: false
					}
				]
			}
		]
	},
	{
		"frageId": "2",
		frage: "Wir nähmen an der Veranstaltung nicht teil",
		fragenTyp: { bezeichnung: "Boolean", component: "Checkbox", id: "" },
		pflichtfrage: true,
		reihenfolge: "2",
		hauptfrageId: "",
		bedingung: "",
		ausschlussFragen: "1",
		abmeldung: false,
		"fragen": [
			{
				"frageId": "6",
				frage: "Wir werden vertreten durch",
				fragenTyp: { bezeichnung: "String", component: "Text", id: "" },
				pflichtfrage: true,
				reihenfolge: "1",
				hauptfrageId: "2",
				bedingung: "",
				ausschlussFragen: "",
				abmeldung: false,
				fragen: []
			}
		]
	}
];

export const EXAMPLE_SAVE_STR = '{"question_1":true,"question_3":"2","question_4":"name1","question_5":null,"question_4_2":"name2","question_5_2":true}';
export const EXAMPLE_SAVE_OBJ = {
	question_1: true,
	question_3: 2,
	question_4: "name1",
	question_5: null,
	question_4_2: "name2",
	question_5_2: true
};

export const backendTypeToComponentType: { [key:string]: "check"|"number"|"text"|"textarea" } = {
	"Boolean": "check",
	"String": "text",
	"Number": "number",
	"Text": "textarea",
	"Mehrwach_Unterfragen": "number",
	"MehrwachUnterfragen": "number"
};

export const BACKEND_QUESTION_TYPES = [
	{ ft_id: "1", ft_bezeichnung: "Boolean", ft_component: "CheckBox" },
	{ ft_id: "2", ft_bezeichnung: "String", ft_component: "Input" },
	{ ft_id: "3", ft_bezeichnung: "Number", ft_component: "InputNumber" },
	{ ft_id: "4", ft_bezeichnung: "Text", ft_component: "TextArea" },
	{ ft_id: "5", ft_bezeichnung: "MehrwachUnterfragen", ft_component: "InputNumber" },
];


export class Answer {

	ebeId = "";
	vbAngemeldet = false;
	vbAntwort = "";
	vbId: null | string = null;
	veranstaltungId = "";

}
